import { GET_PROFILE, GET_WISHLIST_ITEMS, ADD_WISHLIST, DELETE_WISHLIST, GET_APPEARANCE, UPDATE_PROFILE, UPDATE_PROFILE_ERR, GET_BLOGGER_PROFILE, GET_BLOGGER_APPEARANCE } from '../actions/profile/type';
import { GET_ADDRESSES, SAVE_ADDRESS, EDIT_ADDRESS, DELETE_ADDRESS, SET_DEFAULT } from '../actions/address/type';
import { DEAUTH } from '../actions/auth/type';

const initState = { profile: null, appearance: null, blogger_profile: null, blogger_appearance: null, addresses: [], saveAddress: null, editAddress: null, deleteAddress: null, wishlist_mats: [], addWishlistResult: null, deleteWishlistResult: null, setDefaultAddress: null, updateProfileResult: null, updateProfileErr: null };
export default function (state = initState, action) {
    switch (action.type) {
        case GET_PROFILE:
            return { ...state, profile: action.payload }
        case GET_APPEARANCE:
            return { ...state, appearance: action.payload };
        // case GET_NOTICE:
        //     return {...state, data_notice: action.payload.data, count_notice: action.payload.count, order_count: action.payload.orderCount}
        // case UPDATE_NOTICE:
        //     return {...state, updateUserNotification: action.payload}
        case GET_BLOGGER_PROFILE:
            return { ...state, blogger_profile: action.payload }
        case GET_BLOGGER_APPEARANCE:
            return { ...state, blogger_appearance: action.payload };
        case DEAUTH:
            return { ...state, profile: null }
        case GET_ADDRESSES:
            return { ...state, addresses: action.payload }
        case SAVE_ADDRESS:
            return { ...state, saveAddress: action.payload }
        case EDIT_ADDRESS:
            return { ...state, editAddress: action.payload }
        case DELETE_ADDRESS:
            return { ...state, deleteAddress: action.payload };
        case SET_DEFAULT:
            return { ...state, setDefaultAddress: action.payload };
        case GET_WISHLIST_ITEMS:
            return { ...state, wishlist_mats: action.payload };
        case ADD_WISHLIST:
            return { ...state, wishlistID: action.uid, addWishlistResult: action.payload };
        case DELETE_WISHLIST:
            return { ...state, wishlistID: action.uid, deleteWishlistResult: action.payload };
        case UPDATE_PROFILE:
            return { ...state, updateProfileResult: action.payload, updateProfileErr: null };
        case UPDATE_PROFILE_ERR:
            return { ...state, updateProfileErr: action.payload };
        default:
            return { ...state };
    }
}